// No imports: the export hook loads this eagerly to check the timezone before
// fetching, so it must not pull in exceljs or jszip.
const validTimezones = new Set<string>();

/**
 * Throws unless `timezone` is an IANA timezone this runtime knows.
 *
 * date-fns-tz doesn't do this for us: given "" it silently writes UTC times
 * with the machine's UTC offset, and an unknown zone fails with a bare
 * `RangeError`. `Intl` rejects unknown zones and works in the browser.
 * Validated zones are remembered, since `toExportRow` checks once per row.
 */
export function assertExportTimezone(timezone: string): void {
  if (validTimezones.has(timezone)) return;
  const invalid = new Error(`Invalid export timezone "${timezone}"`);
  if (!timezone.trim()) throw invalid;
  try {
    new Intl.DateTimeFormat("en-AU", { timeZone: timezone });
  } catch {
    throw invalid;
  }
  validTimezones.add(timezone);
}
